(ns common.schema.entities.rotation-period-override.options)

(def override-type-options
  [{:key :rotation-period-override.type/skip
    :label "Skip"}
   {:key :rotation-period-override.type/template-override
    :label "Template override"}])
